// Enkel samtyckeslagring för cookies / trackers (GDPR).
//
// - Sparas i localStorage under nyckeln `cookie_consent_v1`.
// - Värden: `"accepted"` = alla analys/marketing-cookies OK,
//           `"rejected"` = endast nödvändiga cookies.
// - Bump `_v1` -> `_v2` om samtyckesomfånget ändras (t.ex. nya integrationer)
//   för att tvinga fram nytt val från befintliga besökare.

const KEY = "cookie_consent_v1";

export function getConsent() {
  if (typeof window === "undefined") return null;
  try {
    return window.localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function setConsent(value) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(KEY, value);
    window.dispatchEvent(new Event("cookie-consent-changed"));
  } catch {
    // silent — privatläge kan blockera
  }
}

export function hasAccepted() {
  return getConsent() === "accepted";
}
